'use client';

import { SimpleCard, Typography } from '@polyseme/design-system';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import { images } from '~/landing/assets';

export const ContentSection = () => {
  const t = useTranslations('landing.germen.simulator');

  return (
    <section id="content">
      <div className="w-full gap-10 py-16" id="description">
        <Typography className="text-center text-2xl font-normal text-muted-foreground md:whitespace-pre-wrap md:text-4xl">
          {t('content.description')}
        </Typography>
      </div>
      <div className="relative w-full py-16">
        <SimpleCard className="absolute left-1/2 top-1/2 w-[calc(100%-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-3xl md:max-w-lg">
          <div className="flex w-full flex-col gap-4 md:gap-6">
            <Typography
              as="h3"
              className="text-center text-2xl font-medium md:whitespace-pre-wrap md:text-4xl"
            >
              {t('content.imageCard.title')}
            </Typography>
            <Typography className="text-center text-base">
              {t('content.imageCard.description')}
            </Typography>
          </div>
        </SimpleCard>
        <Image
          alt={t('hero.alt')}
          className="h-[550px] w-full rounded-3xl object-cover md:h-auto"
          height={1080}
          src={images.germen.handshake}
          width={1920}
        />
      </div>
    </section>
  );
};
